import { render } from "./ConfirmPayment.vue?vue&type=template&id=dd057142&scoped=true"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js"

import "./ConfirmPayment.vue?vue&type=style&index=0&id=dd057142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd057142"]])

export default __exports__